var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpellcheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 71.6C116.6 71.6 89.2 99.1 89.2 132.9C89.2 146 93.6 158.9 101.6 169.4L74.3 196.9C70.9 200.3 70.8 205.8 74.3 209.3C77.7 212.7 83.2 212.8 86.7 209.3L114 181.8C124.5 189.8 137.4 194.2 150.5 194.2C184.4 194.2 211.8 166.7 211.8 132.9C211.8 99.1 184.3 71.6 150.5 71.6ZM150.5 176.7C126.3 176.7 106.7 157.1 106.7 132.9C106.7 108.7 126.3 89.1 150.5 89.1C174.7 89.1 194.3 108.7 194.3 132.9C194.3 157.1 174.7 176.7 150.5 176.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3 166.4C182.9 166.4 180.9 164.9 180.2 162.5L170.5 128.5L160.8 162.5C160 165.4 157.2 167 154.3 166.3C151.4 165.5 149.8 162.7 150.5 159.8C150.5 159.7 150.5 159.6 150.6 159.6L165.4 107.8C166.2 105 169.1 103.4 172 104.2C173.8 104.7 175.2 106.1 175.6 107.8L190.4 159.6C191.2 162.4 189.6 165.3 186.8 166.2C186.3 166.3 185.8 166.4 185.3 166.4Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 152.2H159.6C156.7 152.2 154.3 149.8 154.3 146.9C154.3 144 156.7 141.6 159.6 141.6H181.5C184.4 141.6 186.8 144 186.8 146.9C186.8 149.8 184.5 152.2 181.5 152.2Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpellcheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spellcheck.b7e1378a.svg";
export { ForwardRef as ReactComponent };